import { createI18n } from 'vue-i18n';

const SUPPORTED = ['en', 'nl', 'fr'];

// Base translations (existing keys, used by the public expert/booking pages)
const messages = {
  en: { ...require('./translations/en.json') },
  nl: { ...require('./translations/nl.json') },
  fr: { ...require('./translations/fr.json') },
};

// Section translations: src/translations/sections/<section>.json
// Each file looks like { "en": { ... }, "nl": { ... }, "fr": { ... } }
// and is exposed under its file name, e.g. $t('auth.sign_in') from auth.json.
const sections = require.context('./translations/sections', false, /\.json$/);
sections.keys().forEach((file) => {
  const name = file.replace(/^\.\//, '').replace(/\.json$/, '');
  const content = sections(file);
  SUPPORTED.forEach((lang) => {
    messages[lang][name] = content[lang] || {};
  });
});

const stored = (() => {
  try { return localStorage.getItem('selectedLanguage'); } catch (e) { return null; }
})();

const i18n = createI18n({
  locale: SUPPORTED.includes(stored) ? stored : 'en',
  fallbackLocale: 'en',
  messages,
});

export default i18n;
